<template>
	<div class="index">
		<div class="headerBox flexBox">
			<div class="title" @click="goHome">{{ title }}</div>
			<div class="menuCtr el-icon-s-fold" @click="isCollapse = !isCollapse"></div>
			<div class="right">
				<el-input placeholder="请输入内容" suffix-icon="el-icon-search" size="mini" class="searchBox" v-model="searchValue"></el-input>
				<el-dropdown @command="headercommand">
					<span class="el-dropdown-link">
						{{ u_name }}
						<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command='userinfo'>用户信息</el-dropdown-item>
						<el-dropdown-item command='loginout'>退出</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
		<div class="contentBox">
			<div class="menuBox" v-if="!isCollapse">
				<el-menu :default-openeds="opendsindex" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" background-color="#eeeeee" active-text-color="#ffffff">
					<el-menu-item :index="item.l_id" v-for="item in menu" :key="item.l_id" v-if="item.l_haveson == 0" @click="go(item)">
						<i :class="item.l_icon || 'el-icon-menu'"></i>
						<span slot="title">{{ item.l_name }}</span>
					</el-menu-item>
					<el-submenu :index="item.l_id" v-for="item in menu" :key="item.l_id" v-if="item.l_haveson == 1" background-color="#eeeeee" active-text-color="#ffffff">
						<template slot="title" @click="go(i)">
							<i :class="item.l_icon || 'el-icon-location'"></i>
							<span>{{ item.l_name }}</span>
						</template>
						<el-menu-item-group v-for="(i, idx1) in item.sonlist" :key="idx1">
							<el-menu-item @click="go(i)" :index="i.l_id">{{ i.l_name }}</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
				</el-menu>
			</div>
			<div v-if="isCollapse">
				<el-menu  class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" background-color="#eeeeee" active-text-color="#ffffff" :collapse="isCollapse">
					<el-menu-item :index="item.l_id" v-for="item in menu" :key="item.l_id" v-if="item.l_haveson == 0" @click="go(item)">
						<i :class="item.l_icon || 'el-icon-menu'"></i>
						<span slot="title">{{ item.l_name }}</span>
					</el-menu-item>
					<el-submenu :index="item.l_id" v-for="item in menu" :key="item.l_id" v-if="item.l_haveson == 1" background-color="#eeeeee" active-text-color="#ffffff">
						<template slot="title" @click="go(i)">
							<i :class="item.l_icon || 'el-icon-location'"></i>
							<span>{{ item.l_name }}</span>
						</template>
						<el-menu-item-group v-for="(i, idx1) in item.sonlist" :key="idx1">
							<el-menu-item @click="go(i)" :index="i.l_id">{{ i.l_name }}</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
				</el-menu>
			</div>
			<div class="realView">
				<el-tabs ref="el-tabs" v-model="activeName" @edit="handleEdit" @tab-click="handleClick" @tab-remove="handleRermove">
					<el-tab-pane :label="item.l_name" :name="item.l_name" v-for="(item,index) in tablist" :key="item.l_id" :closable="item.l_name != '我的桌面'">
						<desktop ref="desktop" v-if="item.l_id=='0'" />
						<!-- <packagelist v-if="item.l_id == '1'||item.l_id=='2'" /> -->
						<createorder v-else-if="item.l_id == '38'
						|| item.l_id == '28'|| item.l_id == '65'|| item.l_id == '112'|| item.l_id == '113'
						|| item.l_id == '114'|| item.l_id == '115'|| item.l_id == '116'|| item.l_id == '71'
						|| item.l_id == '72'|| item.l_id == '89'|| item.l_id == '91'|| item.l_id == '93'
						|| item.l_id == '95'|| item.l_id == '326'||item.l_id=='227'|| 
						item.l_id == '416'|| item.l_id == '508'|| item.l_id == '628'|| item.l_id == '630'" 
						:urlparam="urlparam"/>
						<orderimport v-else-if="item.l_id == '4' || item.l_id == '75'|| item.l_id == '289'
						|| item.l_id == '345'||item.l_id=='348'||item.l_id=='369' " :urlparam="urlparam" />
						<rolelist v-else-if="item.l_id == '15'" />
						<addrole v-else-if="item.l_id == '17' || item.l_id == '修改角色'" :urlparam="urlparam" />
						<userlist v-if="item.l_id == '11'" />
						<inlist v-else-if="item.l_id == '30'" />
						<outlist v-else-if="item.l_id == '32'" />
						<!-- <storagein v-if="item.l_id == '34'" :urlparam="urlparam" /> -->
						<storageout v-else-if="item.l_id == '35'||item.l_id == '34'" :urlparam="urlparam" />
						<orderdetail v-else-if="item.l_id == '76'||item.l_id == '44'||item.l_id == '23'||item.l_id == '24'||item.l_id == '25'||item.l_id == '26'||item.l_id == '27'||item.l_id == '118'||item.l_id == '132'||item.l_id == '134'||item.l_name=='订单详情'" :urlparam="urlparam" />
						<logisticstrashlist v-else-if="item.l_id == '78'" :urlparam="urlparam" />
						<orderlist v-else-if="item.l_id == '49'" :urlparam="urlparam" />
						<routeorder v-else-if="item.l_id == '62'" :urlparam="urlparam"></routeorder>
						<logistics v-else-if="item.l_id == '63'" :urlparam="urlparam"></logistics>
						<cwscheme v-else-if="item.l_id == '83'" :urlparam="urlparam"></cwscheme>
						<setscheme v-else-if="item.l_id == '85'||item.l_id == '86'" :urlparam="urlparam"></setscheme>
						<vipcharge v-else-if="item.l_id == '97'" :urlparam="urlparam"></vipcharge>
						<vipbill v-else-if="item.l_id == '98'" :urlparam="urlparam"></vipbill>
						<userinfo v-else-if="item.l_id == '用户信息'" :urlparam="urlparam"></userinfo>
						<createinternational v-else-if="item.l_id == '106'||item.l_type=='createinternational'" :urlparam="urlparam"></createinternational>
						<vipchargemove v-else-if="item.l_id == '107'" :urlparam="urlparam"></vipchargemove>
						<createlogisticsorderbatch v-else-if="item.l_id=='108'" :urlparam="urlparam"></createlogisticsorderbatch>
						<createinternationalfedex v-else-if="item.l_id == '109'||item.l_type=='createinternational_fedex'" :urlparam="urlparam"></createinternationalfedex>
						<orderpayshop v-else-if="item.l_id=='120'" :urlparam="urlparam"></orderpayshop>
						<orderpayzb v-else-if="item.l_id=='121'" :urlparam="urlparam"></orderpayzb>
						<orderrate v-else-if="item.l_id=='138'" :urlparam="urlparam"></orderrate>
						<myworklist v-else-if="item.l_id=='145'" :urlparam="urlparam"></myworklist>
						<handleworklist v-else-if="item.l_id=='155'" :urlparam="urlparam"></handleworklist>
						<workcontext v-else-if="item.l_id=='149'||item.l_id=='164'" :urlparam="urlparam"></workcontext>
						<handlework v-else-if="item.l_id=='151'||item.l_id=='153'||item.l_id=='154'||item.l_id=='159'||item.l_id=='161'||item.l_id=='162'||item.l_id=='163'" :urlparam="urlparam"></handlework>
						<baselist v-if="item.l_id=='165'" :urlparam="urlparam"></baselist>
						<chargepaybills v-else-if="item.l_id=='170'" :urlparam="urlparam"></chargepaybills>
						<handlelog v-else-if="item.l_id=='173'" :urlparam="urlparam"></handlelog>
						<handlefeebook v-else-if="item.l_id=='175'" :urlparam="urlparam"></handlefeebook>
						<addfeebook v-else-if="item.l_id=='177'||item.l_id=='178'" :urlparam="urlparam"></addfeebook>
						<myfeebook v-else-if="item.l_id=='179'" :urlparam="urlparam"></myfeebook>
						<customerlist v-else-if="item.l_id=='184'" :urlparam="urlparam"></customerlist>
						<addcustomer v-else-if="item.l_id=='186'||item.l_id=='188'" :urlparam="urlparam"></addcustomer>
						<customerdetail v-else-if="item.l_id=='189'||item.l_id=='196'||item.l_id=='197'||item.l_id=='198'" :urlparam="urlparam"></customerdetail>
						<customertodeal v-else-if="item.l_id=='192'" :urlparam="urlparam"></customertodeal>
						<shoplist v-if="item.l_id=='8'" :urlparam="urlparam"></shoplist>
						<setuser v-else-if="item.l_id=='201'" :urlparam="urlparam"></setuser>
						<collectpay v-else-if="item.l_id=='204'" :urlparam="urlparam"></collectpay>
						<addcollectpay v-else-if="item.l_id=='206'||item.l_id=='207'" :urlparam="urlparam"></addcollectpay>
						<collectpayreport v-else-if="item.l_id=='210'" :urlparam="urlparam"></collectpayreport>
						<cargolist v-else-if="item.l_id=='212'" :urlparam="urlparam"></cargolist>
						<addcargo v-else-if="item.l_id=='215'||item.l_id=='216'||item.l_id=='310'||item.l_id=='311'||item.l_id=='437'||item.l_id=='439'" :urlparam="urlparam"></addcargo>
						<stock_inlist v-else-if="item.l_id=='221'" :urlparam="urlparam"></stock_inlist>
						<stock_outlist v-else-if="item.l_id=='230'" :urlparam="urlparam"></stock_outlist>
						<stock_out v-else-if="item.l_id=='400'" :urlparam="urlparam"></stock_out>
						<stocklist v-else-if="item.l_id=='229'" :urlparam="urlparam"></stocklist>
						<stock_outlist_plan v-else-if="item.l_id=='395'" :urlparam="urlparam" :l_id="item.l_id"></stock_outlist_plan>
						
						<haitaolist v-else-if="item.l_id=='238'" :urlparam="urlparam"></haitaolist>
						<haitaocreateorder v-else-if="item.l_id=='240'||item.l_id=='251'||item.l_id=='266'||item.l_id=='267'" :urlparam="urlparam"></haitaocreateorder>
						<haitaotrashlist v-else-if="item.l_id=='262'" :urlparam="urlparam"></haitaotrashlist>
						<wtjlist v-else-if="item.l_id == '268'" />
						<remindset v-else-if="item.l_id=='271'"></remindset>
						<harvestlist v-else-if="item.l_id=='272'"></harvestlist>
						<harvest v-else-if="item.l_id=='274'" :urlparam="urlparam"></harvest>
						<storagein v-else-if="item.l_id=='276'" :urlparam="urlparam"></storagein>
						<shelves v-else-if="item.l_id=='279'" :urlparam="urlparam"></shelves>
						<shelveslist v-else-if="item.l_id=='277'" :urlparam="urlparam"></shelveslist>
						<wtjin v-else-if="item.l_id=='284'" :urlparam="urlparam"></wtjin>
						<takephoto v-else-if="item.l_id=='285'" :urlparam="urlparam"></takephoto>
						<shopcargosort v-else-if="item.l_id=='297'" :urlparam="urlparam"></shopcargosort>
						<brandlist v-else-if="item.l_id=='300'" :urlparam="urlparam"></brandlist>
						<speclist v-else-if="item.l_id=='305'" :urlparam="urlparam"></speclist>
						<index_banner v-else-if="item.l_id=='313'||item.l_id=='455'" :urlparam="urlparam"></index_banner> 
						<index_cargolist v-else-if="item.l_id=='314'||item.l_id=='456'" :urlparam="urlparam"></index_cargolist>
						<index_topnav v-else-if="item.l_id=='315'||item.l_id=='457'" :urlparam="urlparam"></index_topnav>
						<scanprint v-else-if="item.l_id=='325'||item.l_id=='351'" :urlparam="urlparam"></scanprint>
						<cargotaxschemelist v-else-if="item.l_id=='328'" :urlparam="urlparam"></cargotaxschemelist>
						<cargotaxscheme v-else-if="item.l_id=='319'||item.l_id=='320'" :urlparam="urlparam"></cargotaxscheme>
						<postallist v-else-if="item.l_id=='365'" :urlparam="urlparam"></postallist>
						<trashlistnew v-else-if="item.l_id == '367'||item.l_id == '40'||item.l_id == '525'" :urlparam="urlparam" :l_id="item.l_id" :p_sys="item.l_tablename"></trashlistnew>
						
						<cargoshelves v-else-if="item.l_id == '385'" :urlparam="urlparam" :l_id="item.l_id" :p_sys="item.l_tablename"></cargoshelves>
						<stockinlistplan v-else-if="item.l_id == '386'" :urlparam="urlparam" :l_id="item.l_id" :p_sys="item.l_tablename"></stockinlistplan>
						<createstockinfo v-else-if="item.l_id == '388'||item.l_id=='389'||item.l_id=='223'||item.l_id=='397'||item.l_id=='398'||item.l_id=='412'||item.l_id=='413'||item.l_id=='414'||item.l_id=='415'||item.l_id=='427'||item.l_id=='428'" :urlparam="urlparam" :l_id="item.l_id" :p_sys="item.l_tablename"></createstockinfo>
						<reportcargostock v-else-if="item.l_id == '410'" ></reportcargostock>
						<cargostockwarning v-else-if="item.l_id=='418'"></cargostockwarning>
						<stocktakinglist v-else-if="item.l_id=='421'"></stocktakinglist>
						<stocktaking v-else-if="item.l_id=='423'||item.l_id=='424'||item.l_id=='426'" :urlparam="urlparam"></stocktaking>
						<index_banner_sort v-if="item.l_id=='433'||item.l_id=='459'" :urlparam="urlparam"></index_banner_sort>
						<index_banner_brand v-if="item.l_id=='434'||item.l_id=='458'" :urlparam="urlparam"></index_banner_brand> 
						<printset v-else-if="item.l_id=='461'||item.l_id=='510'||item.l_id=='614'" :urlparam="urlparam"></printset>
						<controlcenter v-else-if="item.l_pagetype!=''" :ref="'control_'+item.l_id" :item="item" :urlparam="urlparam"></controlcenter>
						<packagelist v-if="item.l_id == '1'||item.l_id=='2'" />
						<printlabel v-if="item.l_id=='467'" :urlparam="urlparam"></printlabel>
					</el-tab-pane>
				</el-tabs>
			</div>
			<exportwin ref="exportwinnew"></exportwin>
			<submitqg ref="submitqg"></submitqg>
			<importwin ref="importwinnew"></importwin>
			<importFile ref="importfilenew"></importFile>
			<maindialog ref="maindialog"></maindialog>
			<exportbysearch ref="exportbysearch"></exportbysearch>
			<savefeelisttemp ref="savefeelisttemp"></savefeelisttemp>
			<getfeelisttemp ref="getfeelisttemp" @getfeecallback="getfeecallback"></getfeelisttemp>
			<printhandler ref="printhandler"></printhandler>
			<downpic ref="downpic"></downpic>
			<!-- <errorwin ref="main_errorwin" @closeerrorwin="closeerrorwin"></errorwin>
			<errorwinbtn ref="main_errorwinbtn" @errorwincallback="errorwincallback"></errorwinbtn> -->
		</div>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import downpic from '@/pages/baseinfo/downpic.vue';
import printhandler from '@/components/order/printhandler.vue';
import savefeelisttemp from '@/components/tools/savefeelisttemp.vue';
import getfeelisttemp from '@/components/tools/getfeelisttemp.vue';
import exportbysearch from '@/components/tools/exportbysearch.vue';//按筛选条件导出
import importFile from '@/components/tools/importFile_new.vue'; //文件上传
import errorwin from '@/components/order/errorwin.vue';
import errorwinbtn from '@/components/tools/errorwinbtn.vue';
import importwin from '@/components/tools/importwin_new.vue'; //万能导入
import controlcenter from '@/pages/main/controlcenter';
import maindialog from '@/pages/main/maindialog';
import desktop from '@/pages/index/desktop';
import printlabel from '@/pages/baseinfo/printlabel';
import exportwin from '@/components/tools/exportwin_new.vue';
import packagelist from '@/pages/packagemanage/packagelist';
import createorder from '@/pages/packagemanage/createorder_pkg';
import orderimport from '@/pages/packagemanage/orderimport';
import orderdetail from '@/pages/packagemanage/orderdetail';
import rolelist from '@/pages/user/rolelist';
import addrole from '@/pages/user/addrole';
import userlist from '@/pages/user/index';
import inlist from '@/pages/wm/inlist';
import outlist from '@/pages/wm/outlist';
import trashlist from '@/pages/Trash/trashlist';
import logisticstrashlist from '@/pages/logisticsmanager/trashlist';
import orderlist from '@/pages/ordermanager/orderlist';
import routeorder from '@/pages/ordermanager/routeorder';
import logistics from '@/pages/logisticsmanager/logistics';
import createlogisticsorder from '@/pages/logisticsmanager/createlogisticsorder';
import cwscheme from '@/pages/cw/cwscheme';
import setscheme from '@/pages/cw/setscheme';
import vipcharge from '@/pages/cw/vipcharge';
import vipbill from '@/pages/cw/vipbill';
import userinfo from '@/pages/user/userinfo';
import createinternational from '@/pages/logisticsmanager/createinternational';
import vipchargemove from '@/pages/cw/vipcharge_move';
import createlogisticsorderbatch from '@/pages/logisticsmanager/createlogisticsorder_batch';
import createinternationalfedex from '@/pages/logisticsmanager/createinternational_fedex';
import orderpayshop from '@/pages/cw/orderpay_shop';
import orderpayzb from '@/pages/cw/orderpay_zb';
import storageout from '@/pages/wm/storageout';
//import predictfee from '@/pages/cw/predictfee'; //预估费用
import myworklist from '@/pages/workorders/myworklist'; //客服管理-提交服务单
import handleworklist from '@/pages/workorders/handleworklist'; //客服管理-处理服务单
import workcontext from '@/pages/workorders/workcontext'; //新增服务单
import handlework from '@/pages/workorders/handlework'; //处理服务单
import baselist from '@/pages/baseinfo/baselist'; //基础资料
import chargepaybills from '@/pages/cw/chargepaybills'; //交易明细
import handlelog from '@/pages/workorders/handlelog'; //日志查询
import handlefeebook from '@/pages/cw/handlefeebook'; //操作记账
import addfeebook from '@/pages/cw/addfeebook'; //新增/修改操作记账
import myfeebook from '@/pages/cw/myfeebook'; //我的账单
import customerlist from '@/pages/crm/customerlist.vue'; //客户管理
import addcustomer from '@/pages/crm/addcustomer.vue'; //添加/修改客户
import customerdetail from '@/pages/crm/customer_detail'; //客户信息详情
import customertodeal from '@/pages/crm/customer_todeal'; //客户待处理事项列表
import shoplist from '@/pages/group/shoplist'; //门店管理列表
import setuser from '@/pages/group/setuser'; //设置门店人员
import collectpay from '@/pages/cw/collectpay'; //收款付款单列表
import addcollectpay from '@/pages/cw/addcollectpay'; //新增/修改 收款付款单
import collectpayreport from '@/pages/cw/collectpay_report';
import cargolist from '@/pages/baseinfo/cargolist';
import addcargo from '@/pages/baseinfo/addcargo';
import stock_inlist from '@/pages/stockmanager/stock_inlist';
import stock_outlist from '@/pages/stockmanager/stock_outlist';
import stock_out from '@/pages/stockmanager/stock_out';//验货出库
import stocklist from '@/pages/stockmanager/stocklist';
import stock_outlist_plan from '@/pages/stockmanager/stock_outlist_plan';
import haitaolist from '@/pages/haitaomananger/haitaolist';
import haitaocreateorder from '@/pages/haitaomananger/createorder_haitao';
import haitaotrashlist from '@/pages/haitaomananger/trashlist';
import wtjlist from '@/pages/wm/wtjlist';
import remindset from '@/pages/msg/remindset';
import harvestlist from '@/pages/wm/harvestlist';
import harvest from '@/pages/wm/harvest';
import storagein from '@/pages/wm/storagein';
import shelves from '@/pages/wm/shelves'; //上架
import shelveslist from '@/pages/wm/shelveslist'; //上架列表
import wtjin from '@/pages/wm/wtjin'; //问题件入库
import takephoto from '@/pages/index/takephoto'; //拍照
import orderrate from '@/pages/packagemanage/orderrate'; //计算费用
import shopcargosort from '@/pages/baseinfo/sortlist'; //商城的商品分类列表 
import brandlist from '@/pages/baseinfo/brandlist'; //商城的商品品牌列表 
import speclist from '@/pages/baseinfo/speclist'; //商城的商品规格列表
import index_banner from '@/pages/shop/index_banner'; //商城首页轮播图
import index_cargolist from '@/pages/shop/index_cargolist'; //商城首页商品列表
import index_topnav from '@/pages/shop/index_topnav'; //商城首页顶部商品导航列表
import scanprint from '@/pages/packagemanage/scanprint'; 
import cargotaxschemelist from '@/pages/baseinfo/cargotaxscheme_list'; 
import cargotaxscheme from '@/pages/baseinfo/cargotaxscheme'; 
import postallist from '@/pages/postalmananger/postallist'; //邮件包裹管理
import trashlistnew from '@/pages/Trash/trashlistnew'; //通用型回收站
import cargoshelves from '@/pages/wm/cargoshelves'; //商品上架
import stockinlistplan from '@/pages/stockmanager/stock_inlist_plan'; //入库计划单
import stockinplan from '@/pages/stockmanager/stock_in_plan'; //入库计划单列表
import createstockinfo from '@/pages/stockmanager/createstockinfo'; //仓库管理--入库\出库
import reportcargostock from '@/pages/report/cargostock'; //商品库存流水账
import cargostockwarning from '@/pages/report/cargostock_warning'; //商品预警
import stocktakinglist from '@/pages/stockmanager/stock_taking_list'; //盘点管理记录
import stocktaking from '@/pages/stockmanager/stock_taking'; //仓库商品盘点
import index_banner_sort from '@/pages/shop/index_banner_sort'; //商城首页商品分类导航列表
import index_banner_brand from '@/pages/shop/index_banner_brand'; //商城首页商品品牌导航列表
import printset from '@/pages/user/printset';
import submitqg from '@/components/qg/submitqg.vue';//平台下载订单
export default {
	name: 'pagemain',
	components: {
		downpic,
		printhandler,
		savefeelisttemp,
		getfeelisttemp,
		exportbysearch,
		importFile,
		errorwin,
		errorwinbtn,
		importwin,
		submitqg,
		exportwin,
		printlabel,
		controlcenter,
		maindialog,
		desktop,
		packagelist,
		createorder,
		rolelist,
		addrole,
		userlist,
		//orderinport,
		orderimport,
		storageout,
		inlist,
		outlist,
		orderdetail,
		trashlist,
		orderlist,
		routeorder,
		logistics,
		createlogisticsorder,
		logisticstrashlist,
		cwscheme,
		setscheme,
		vipcharge,
		vipbill,
		userinfo,
		createinternational,
		vipchargemove,
		createlogisticsorderbatch,
		createinternationalfedex,
		orderpayshop,
		orderpayzb,
		//predictfee,
		myworklist,
		handleworklist,
		workcontext,
		handlework,
		baselist,
		chargepaybills,
		handlelog,
		handlefeebook,
		addfeebook,
		myfeebook,
		customerlist,
		addcustomer,
		customerdetail,
		customertodeal,
		shoplist,
		setuser,
		collectpay,
		addcollectpay,
		collectpayreport,
		cargolist,
		addcargo,
		stock_inlist,
		stock_outlist,
		stocklist,
		stock_out,
		stock_outlist_plan,//出库计划单列表
		//stock_out_plan, //出库计划单
		haitaolist,
		haitaocreateorder,
		haitaotrashlist,
		wtjlist,
		remindset,
		harvestlist,
		harvest,
		storagein,
		shelves,
		shelveslist,
		wtjin,
		takephoto,
		orderrate,
		shopcargosort,
		brandlist,
		speclist,
		index_banner,
		index_cargolist,
		index_topnav,
		scanprint,
		cargotaxscheme,
		cargotaxschemelist,
		postallist,
		trashlistnew,
		cargoshelves,
		stockinlistplan,
		stockinplan,
		createstockinfo,
		reportcargostock,
		cargostockwarning,
		stocktaking,
		stocktakinglist,
		index_banner_sort,
		index_banner_brand,
		printset
	},
	data() {
		return {
			urlparam: {
				// pkval:'DL0083423'
			},
			u_name:'',
			activeName: '我的桌面',
			activeIndex: 0,
			activelid:0,
			l_tablename:'',
			searchValue: '',
			title: '',
			isCollapse: false,
			iframeheight: window.innerHeight,
			tablist: [],
			menu: [],
			refresh:[1,2,30,32,40,63,83,11,15,78,98,120,121,144,155,175,179,184,192,204,212,221,225,230,238,262,268,272,277,317,225,365,367,386,395,421,469,473,516],
			opendsindex:[],
			defaultpage:{
				l_id: '0',
				l_name: '我的桌面',
				l_url: 'opentab',
				l_tablename:'',
				l_pagetype:''
			},
			dialogitem:{
				title:'',
				width:'100px',
				l_id:''
			},
			showdialog:false
		};
	},
	mounted() {
		var that = this;
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/index.scss');
			that.checklogin();
		});
		if(localStorage.getItem('webtitle')!=null){
			if(localStorage.getItem('webtitle')!="")
				this.title=localStorage.getItem('webtitle');
		}
		Utils.$on('go', function(msg) {
			that.go(msg);
		});
		Utils.$on('handleRermove', function(msg) {
			that.handleRermove(msg);
		});
		//debugger
		//console.log('加载首页',this.$tool.getcurrenttime());
	},
	methods: {
		checklogin(){
			
			var that=this;
			if(localStorage.getItem('token')==null||localStorage.getItem('token')=='')
				//跳转到登录
				this.$router.push("/login");
			else{
				//根据token获取登录信息
				this.$apipost.post.checklogin().then(res => {
					if(res!=''){
						if(res.state=='1'){
							localStorage.setItem('userid',res.userid);
							localStorage.setItem('u_account',res.uaccount);
							localStorage.setItem('u_name',res.username);
							localStorage.setItem('u_company',res.company);
							localStorage.setItem('vipaccount',res.vipaccount);
							//localStorage.setItem('wxenabled',true);
							localStorage.setItem('token',res.token);
							that.u_name=res.username;
							that.getLeftMenu();
							that.tablist.push(that.defaultpage);
							//加载desktop
							if(that.activeName=='我的桌面'){
								setTimeout(function(){
									that.$refs.desktop[0].init();
								},1000);
							}				
						}else{
							this.$alert('您的登录凭证已过期，请重新登录', '提示', {
							          confirmButtonText: '去登录',
							          callback: action => {
							            var storage = window.localStorage;
							            storage.clear();
							            this.$router.push("/login");
							          }
							        });
						}
					}
					else{
						that.checklogin();
					}
				}).catch(e=>{
					that.checklogin();
				});
			}
		},
		//获取左侧菜单
		getLeftMenu(){
			var that=this;
			this.$apipost.get.getLeftMenu().then(res => {
				//console.log('菜单',res.data);
				if(res!=''){
					that.menu=res.data;
					that.opendsindex=res.openlink;
					localStorage.setItem('menulist', JSON.stringify(that.menu));
				}else{
					that.getLeftMenu();
				}
			}).catch(e=>{
				that.getLeftMenu();
			});
		},
		headercommand(command){
			if(command=='loginout'){
				this.loginout();
			}
			if(command=='userinfo'){
				this.gouserinfo();
			}
		},
		loginout(){
			this.$confirm('确定退出系统吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
			.then(() => {
				 var storage = window.localStorage;
				 storage.clear();
				 this.$router.push("/login");
			})
			.catch(() => {});
		},
		//回首页
		goHome() {
			this.go(that.defaultpage);
		},
		handleEdit(a, b, c) {
			this.$public.setlocal(this);
		},
		handleClick() {
			for (let i = 0; i < this.tablist.length; i++) {
				if (this.activeName == this.tablist[i].l_name) {
					this.activeIndex = i;
					this.activelid=this.tablist[i].l_id;
					break;
				}
			}
			this.$public.setlocal(this);
		},
		handleRermove(a) {
			var isexists=false;
			for (let i = 0; i < this.tablist.length; i++) {
				if (a == this.tablist[i].l_name || a == this.tablist[i].l_url||a==this.tablist[i].l_id) {
					this.tablist.splice(i, 1);
					isexists=true;
					break;
					//this.setlocal(1);
				}
			}
			//debugger
			if(isexists){
				let len = this.tablist.length;
				this.activeName = this.tablist[len - 1].l_name;
				this.activeIndex = len - 1;
				this.activelid=this.tablist[len - 1].l_id;
				this.$public.setlocal(this);
				this.go(this.tablist[len - 1]);
			}
		},
		handleAdd() {
			this.$public.setlocal(this);
		},
		handleOpen(key, keyPath) {
			var menu=this.menu;
			for(var i=0;i<menu.length;i++){
				if(menu[i].l_id==keyPath){
					if (menu[i].l_url == '') 
						break;
					else{
						this.go(menu[i]);
						break;
					}
				}
			}
		},
		handleClose(key, keyPath) {
			//console.log(key, keyPath);
			var menu=this.menu;
			for(var i=0;i<menu.length;i++){
				if(menu[i].l_id==keyPath){
					if (menu[i].l_url == '') 
						break;
					else{
						this.go(menu[i]);
						break;
					}
				}
			}
		},
		go(e){
			debugger
			this.$public.ActionControl(e,this);
		},
		// getlocal() {
		// 	let localtablist = JSON.parse(localStorage.getItem('tablist'));
		// 	this.tablist = localtablist == null || localtablist.length == 0 ? this.tablist : localtablist;
		// 	let count = 0;
		// 	for (let i = 0; i < this.tablist.length; i++) {
		// 		if (location.hash.split('#')[1] == this.tablist[i].l_url) {
		// 			this.activeName = this.tablist[i].l_name;
		// 			this.activelid = this.tablist[i].l_id;
		// 			this.l_tablename=this.tablist[i].l_tablename;
		// 			count++;
		// 		}
		// 	}
		// 	if (count > 0) return; //如果当前页面节点没有打开就添加当前节点到选项卡
		// },
		gouserinfo(){
			this.go({l_url:'/user/userinfo',l_name:'用户信息',l_id:'用户信息'});
		},
		// opendialog(item,urlparam){
		// 	//debugger
		// 	this.showdialog=true;
		// 	this.$nextTick(() => {
		// 		this.$refs.maindialog.init({item:item,urlparam:urlparam});
		// 	});
		// },
		centeraction(paraminfo){
			//debugger
			//ActionControl
		},
		importwincallback(e){
			//debugger
			if(e.refreshgrid){
				setTimeout(function(){
					Utils.$emit('refreshgrid');
				},30); 
			}
		},
		closeerrorwin(e){
			debugger
		},
		errorwincallback(e){
			debugger
		},
		getfeecallback(e){
			//debugger
			var tabs= this.$refs["el-tabs"].$children.filter(function(t){
				return t.name==localStorage.getItem("tabname");
			});
			if(tabs.length>0){
				if(tabs[0].$children[0].$vnode.tag.indexOf('controlcenter')>-1){
					var isexists=false;
					for(var j in tabs[0].$children[0].$children[0].$children[0].$refs){
						if(e.feetype=='2'&&j.indexOf("_ys")>-1){
							//debugger
							isexists=true;
							tabs[0].$children[0].$children[0].$children[0].$refs[j].feecallback(e);
							break;
						}
						if(e.feetype=='1'&&j.indexOf("_yf")>-1){
							isexists=true;
							tabs[0].$children[0].$children[0].$children[0].$refs[j].feecallback(e);
							break;
						}
						
					}
				}
			}
		}
	}
};
</script>
<!-- <style scoped>
html body{
	overflow-y:hidden;
	overflow-x:hidden;
}
</style> -->